module.exports = __webpack_public_path__ + "static/media/ic_自定义分类.7c8a08fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_自定义分类.svg
// module id = 339
// module chunks = 0